import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function Step5ReviewSubmit({ formData, onBack }) {
  const navigate = useNavigate();

  const handleSubmit = async () => {
    try {
      const response = await axios.post('/api/horses', formData);
      console.log('Horse created successfully!', response.data);
      navigate('/post-success');
    } catch (error) {
      console.error('Error submitting horse:', error);
      alert('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold mb-4">Review & Submit</h2>
    
    <div className="columns-md">
      {/* Horse Info */}
        <div className="space-y-2">
            <h3 className="font-bold">Horse Info</h3>
            <p><strong>Name:</strong> {formData.horseName}</p>
            <p><strong>Breed:</strong> {formData.breed}</p>
            <p><strong>Sex:</strong> {formData.sex}</p>
            <p><strong>Age:</strong> {formData.age}</p>
            <p><strong>Height:</strong> {formData.height}</p>
            <p><strong>Color:</strong> {formData.color}</p>
            <p><strong>Description:</strong> {formData.description}</p>
        </div>
    </div>

    <div className="columns-md">
      {/* Location */}
      <div className="space-y-2">
        <h3 className="font-bold">Location</h3>
        <p><strong>City:</strong> {formData.city}</p>
        <p><strong>State:</strong> {formData.state}</p>
        <p><strong>Country:</strong> {formData.country}</p>
        <p><strong>Zip Code:</strong> {formData.zip}</p>
      </div>

      {/* Pedigree */}
      <div className="space-y-2">
            <h3 className="font-bold">Pedigree</h3>
            <p><strong>Sire:</strong> {formData.sire}</p>
            <p><strong>Dam:</strong> {formData.dam}</p>
            <p><strong>Grandsire (Sire's side):</strong> {formData.grandsireSireSide}</p>
            <p><strong>Grandsire (Dam's side):</strong> {formData.grandsireDamSide}</p>
        </div>

      {/* Sale Details */}
      <div className="space-y-2">
        <h3 className="font-bold">Sale Details</h3>
        <p><strong>Sale Type:</strong> {formData.saleType}</p>
        {formData.saleType === "Buy Now" && (
          <p><strong>Buy Now Price:</strong> ${formData.buyNowPrice}</p>
        )}
        {formData.saleType === "Auction" && (
          <p><strong>Starting Bid:</strong> ${formData.auctionStartingPrice}</p>
        )}
        {formData.saleType === "Hybrid" && (
          <>
            <p><strong>Starting Bid:</strong> ${formData.auctionStartingPrice}</p>
            <p><strong>Buy Now Price:</strong> ${formData.buyNowPrice}</p>
          </>
        )}
        <p><strong>Sponsored Listing:</strong> {formData.sponsored ? 'Yes' : 'No'}</p>
      </div>
    </div>

      {/* Media */}
      <div className="space-y-2">
        <h3 className="font-bold">Media</h3>
        {formData.media && formData.media.length > 0 ? (
          <ul className="list-disc list-inside">
            {formData.media.map((item, index) => (
              <li key={index}>
                {item.type === 'photo' ? 'Photo' : 'Video'}: {item.url}
              </li>
            ))}
          </ul>
        ) : (
          <p>No media uploaded.</p>
        )}
      </div>

      {/* Actions */}
      <div className="flex justify-between mt-8">
        <button
          onClick={onBack}
          className="bg-gray-300 text-black py-2 px-6 rounded"
        >
          Back
        </button>
        <button
          onClick={handleSubmit}
          className="bg-green-600 text-white py-2 px-6 rounded hover:bg-green-700"
        >
          Submit Listing
        </button>
      </div>
    </div>
  );
}